import { render, staticRenderFns } from "./RouteHeader.vue?vue&type=template&id=62b45750&"
import script from "./RouteHeader.vue?vue&type=script&lang=js&"
export * from "./RouteHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports